import {AppSvg, CustomSvg, PeopleSvg} from 'assets';

const services = [
  {
    Icon: CustomSvg,
    title: 'Customize System',
    content:
      'Inaccurate appliying of an architecture might result of extreme system complexity and developing tightly coupled software might gives headache to the team, make sure the team are not just developing an application instead we gave more smart customization of software base on the specification.'
  },
  {
    Icon: AppSvg,
    title: 'Software Development',
    content:
      'We solidify the average cost of time and expenses in developing softwares, assuring our software development process are concrete and straight forward to the needs of our valuable clients and assure the software performances, user experience and especially how user friendly our software we developed.'
  },
  {
    Icon: PeopleSvg,
    title: 'Outsourcing',
    content:
      'On our entire career we knew how to evaluate our team members that has participate for the contribution of software specification, we have professional software engineers that has a lot of potential on their field, having a healhty circle connection with concrete relationship to them are greatest part of provisioning resources.'
  }
];

export default services;
